/**
 * Accessibility for select2.
 * @type {{attach: Drupal.behaviors.select2A11y.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const select2Webform_once = once('select2-webform-once',
      'form[data-drupal-selector="webform-submission-state-aid-matter-add-form"] .select-wrapper, ' +
      'form[data-drupal-selector="webform-submission-salary-pension-or-remuneration-add-form"] .select-wrapper, ' +
      'form[data-drupal-selector="webform-submission-contact-add-form"] .select-wrapper, ' +
      'form[data-drupal-selector="webform-submission-kontaktformular-finanzamt-add-form"] .select-wrapper', context);

    $(select2Webform_once).each(function () {
      let $wrapper = $(this);

      setTimeout(function() {
        let $select = $wrapper.find('select');
        let $selectric = $wrapper.find('select').data('selectric');

        // Destroy jQuery Selectric.
        $selectric.destroy();

        // Hide autocomplete field in the dropdown.
        $select.select2({ minimumResultsForSearch: -1 });

        let $select2 = $select.parent().find('.select2');
        let $label = $select.closest('.form-item').find('label')

        // Accessibility for the label.
        Drupal.behaviors.select2A11y.labelAccessibility($select2, $label);

        setTimeout(function() {
          // Accessibility fix for focus.
          $select2.find('.select2-selection').attr('tabindex', '0');
        }, 400);
      }, 400);
    });

    const searchSortSelect2_once = once('search-sort-select2-once', '.block-search-api-sorts', context);

    $(searchSortSelect2_once).each(function () {
      let $wrapper = $(this);

      setTimeout(function() {
        let $select = $wrapper.find('select.select2-hidden-accessible');
        let $select2 = $select.parent().find('.select2');
        let $label = $select.closest('.block-search-api-sorts').find('.block-title')

        // Accessibility for the label.
        Drupal.behaviors.select2A11y.labelAccessibility($select2, $label);

        // Redirect on select change.
        $select.on('select2:select', function (e) {
          let data = e.params.data;

          if (data.id.length) {
            window.location.href = data.id;
          }
        });
      }, 400);
    });
  },
  labelAccessibility: function ($select2, $label) {
    if ( typeof this.elementsIndex === 'undefined' ) {
      this.elementsIndex = 0;
    }
    this.elementsIndex++;
    $select2.attr('id', 'ifm_select2_' + this.elementsIndex);
    $label.attr('for', 'ifm_select2_' + this.elementsIndex);
  },
}
